import { IconButton } from "@material-ui/core"
import { TextBox } from "devextreme-react"
import { generate } from "generate-password-browser";
import RefreshIcon from '@material-ui/icons/Refresh';
import React, { useState } from "react"

function PasswordInput(props){

    const {value, setValue} = props;
    const [mode, setMode] = useState("password")

    function generatePassword(){
         const password = generate({
                length: 16,
                numbers: true,
                symbols: true,
                uppercase: true,
                lowercase: true
            })
        
        setValue({value:password})
        setMode("text");
        
    }

    return(
        <div style={{display: "flex", alignItems: "center", justifyContent: "space-between"}}>
            <span style={{flexGrow: 1}} ><TextBox readOnly mode={mode} height={35} value={value}></TextBox></span>
            <IconButton title="Generar nueva contraseña" onClick={generatePassword}><RefreshIcon htmlColor="#3B5158"/></IconButton>
        </div>
    )
}

export {PasswordInput}